
export const clickAndReveal = `
.click-and-reveal-text {
  text-align: center;

  > div {

    > ul, > ol {
      display: inline-block;
      margin-left: 0px;
    }
  }
}
`;
